export default "__VITE_ASSET__CBycoxfR__"